var _path, _circle, _circle2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 379,
    height: 220,
    viewBox: "0 0 379 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.987 148.54H98.3673V175H70.4673V148.54H6.92727V128.92L60.7473 49H91.8873L40.7673 124.78H71.9073V102.46H98.3673V124.78H117.987V148.54ZM189.482 177.16C178.802 177.16 169.322 174.58 161.042 169.42C152.762 164.14 146.282 156.58 141.602 146.74C137.042 136.9 134.762 125.32 134.762 112C134.762 98.68 137.042 87.1 141.602 77.26C146.282 67.42 152.762 59.92 161.042 54.76C169.322 49.48 178.802 46.84 189.482 46.84C200.162 46.84 209.642 49.48 217.922 54.76C226.202 59.92 232.682 67.42 237.362 77.26C242.042 87.1 244.382 98.68 244.382 112C244.382 125.32 242.042 136.9 237.362 146.74C232.682 156.58 226.202 164.14 217.922 169.42C209.642 174.58 200.162 177.16 189.482 177.16ZM189.482 152.5C197.282 152.5 203.462 149.14 208.022 142.42C212.582 135.7 214.862 125.56 214.862 112C214.862 98.44 212.582 88.3 208.022 81.58C203.462 74.86 197.282 71.5 189.482 71.5C181.682 71.5 175.502 74.86 170.942 81.58C166.382 88.3 164.102 98.44 164.102 112C164.102 125.56 166.382 135.7 170.942 142.42C175.502 149.14 181.682 152.5 189.482 152.5ZM370.058 148.54H350.438V175H322.538V148.54H258.998V128.92L312.818 49H343.958L292.838 124.78H323.978V102.46H350.438V124.78H370.058V148.54Z",
    fill: "#0F2342"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 114,
    r: 70,
    fill: "#0F2342"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 114,
    r: 48,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.cb62da3adf1afcda3915d406a28c7b0e.svg";
export { ForwardRef as ReactComponent };